import { useVisualComponentsContext } from '../../contexts/visualComponents';
import { useQueryStateContext } from '../../contexts';
import { useDuplicateCondition } from 'modules/queryBuilder/hooks/condition';

export const DuplicateButton = () => {
  const { DuplicateConditionButton } = useVisualComponentsContext();
  const { isReadOnly = false } = useQueryStateContext();
  const duplicateCondition = useDuplicateCondition();

  if (isReadOnly) return null;

  return <DuplicateConditionButton isDisabled={isReadOnly} onClick={duplicateCondition} />;
};
